import { IDashboardItem } from 'models/Dashboard';
import { IStatistics } from 'models/Statistics';
import { MOCK_BID_TOKEN, MOCK_HRC721, pastDate, toTokenAmount } from './constants';
import mockNfts from './nfts';

const listedNfts = mockNfts.filter(nft => nft.sale);

const toDashboardItem = (nft: typeof mockNfts[0], index: number): IDashboardItem => ({
  _id: `dashboard-${nft._id}`,
  bidToken: MOCK_BID_TOKEN,
  contractAddress: nft.contract,
  endTime: nft.sale.endTime,
  startTime: nft.sale.startTime,
  isBundle: false,
  nfts: nft,
  price: nft.sale.price,
  saleId: nft.sale.saleId,
  seller: nft.sale.seller,
  statue: 'live',
  type: nft.sale.type,
});

const bidTokenStat = {
  bidToken: MOCK_BID_TOKEN,
  total: 42,
  volume: toTokenAmount(128.5),
};

const statistics: IStatistics = {
  dailyListing: { sales: [bidTokenStat], totalSales: 8 },
  dailySales: { sales: [bidTokenStat], totalSales: 5 },
  weeklyListing: { sales: [bidTokenStat], totalSales: 24 },
  weeklySales: { sales: [bidTokenStat], totalSales: 18 },
  monthlyListing: { sales: [bidTokenStat], totalSales: 96 },
  monthlySales: { sales: [bidTokenStat], totalSales: 72 },
};

const latestListing = listedNfts.slice(0, 8).map(toDashboardItem);

const latestSales = listedNfts.slice(4, 12).map((nft, index) => ({
  ...toDashboardItem(nft, index),
  statue: 'completed',
  startTime: pastDate(10 - index),
  endTime: pastDate(8 - index),
}));

export default {
  statistics,
  latestListing,
  latestSales,
};
